import styled from 'styled-components/macro';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationTopLvl4 } from '@yme/tokens/elevations';
import { INDENT } from '@yme/tokens/sizes';
export const WrapperStyled = styled.div `
  box-sizing: border-box;
  min-width: 393px;
  min-height: 40px;
  background-color: ${colorCoreBlack900Base};
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  padding: ${INDENT.xxxs} ${INDENT.xxs};
  border-radius: ${CORNER_RADIUS.s};
  box-shadow: ${elevationTopLvl4};
  user-select: none;
`;
export const ClickableStyled = styled.div `
  cursor: pointer;
`;
